<template>
  <wd-config-provider
    :customClass="isDark ? 'mall-theme dark-mode page-wraper' : 'mall-theme page-wraper'"
    :themeVars="defaultTheme"
    :theme="theme"
  >
    <slot />
    <wd-toast />
    <global-toast />
    <wd-message-box />
    <global-dialog />
  </wd-config-provider>
</template>

<script lang="ts" setup>
import { useTheme } from '@/hooks/useTheme'
import { useMessage, useToast } from 'wot-design-uni'
import GlobalToast from '@/components/GlobalToast.vue'
import GlobalDialog from '@/components/GlobalDialog.vue'

/**
 * 这里调用一次，是为了解决有些时候，页面没有调用useMessage，而页面组件调用useMessage无效。
 */
useToast()
useMessage()

const { theme, defaultTheme } = useTheme()
const isDark = ref(false)
watch(
  () => theme.value,
  () => {
    isDark.value = theme.value === 'dark'
  },
)
</script>

<style lang="scss" scoped>
.page-wraper {
  box-sizing: border-box;
  min-height: calc(100vh - var(--window-top));
  background: #f7f8fa;
}

.dark-mode.page-wraper {
  background: #222;
}
</style>
